/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconRobot2 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M6 8.252h12M12 4.125c.207 0 .375.168.375.375M11.625 4.5c0-.207.168-.375.375-.375M12 4.875a.375.375 0 0 1-.375-.375M12.375 4.5a.375.375 0 0 1-.375.375M9 11.25h6M10.5 14.25a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zM15 23.25H9l.75-3h4.5l.75 3z" />
        <path d="M18 6.75a6 6 0 1 0-12 0v13.5h12V6.75zM18 23.25h4.5v-10.5a4.5 4.5 0 0 0-4.5-4.5v15zM22.5 20.25H18M6 23.25H1.5v-10.5A4.5 4.5 0 0 1 6 8.25v15zM1.5 20.25H6" />
      </g>
    </svg>
  ),
);
